import {createApp, ref, watch, onMounted} from 'vue';

document.addEventListener('DOMContentLoaded', () => {
    const nav = document.querySelector('.main-navigation nav');

    if (!nav) {
        return;
    }

    createApp({
        setup() {
            const opened = ref('');
            const openedLevel2 = ref('');

            const toggleMenu = (key) => {
                opened.value = opened.value !== key ? key : '';
                if (opened.value !== '') {
                    const level2 = document.querySelectorAll(`li[data-name=${opened.value}] .right-side-wrapper div`);
                    if (level2.length > 0) {
                        level2[0].style.display = 'inline';
                    }
                }
            };

            const showMobileLevel2 = (e, key) => {
                e.preventDefault();
                openedLevel2.value = key;
                if (key === '') {
                    nav.classList.remove('third-level');
                } else {
                    nav.classList.add('third-level');
                    document.querySelectorAll('.level-3-wrapper > div:not(.third-level-header)').forEach(el => {
                        el.style.height = (document.getElementsByClassName('main-navigation')[0].offsetHeight - 100) + 'px';
                    });
                }
            };

            onMounted(() => {
                document.dispatchEvent(new Event('topNavMounted'));
            });

            watch(opened, (val) => {
                document.getElementById('navigation-overlay').style.display = val !== '' ? 'block' : 'none';
            });

            return {
                opened,
                openedLevel2,
                toggleMenu,
                showMobileLevel2,
            };
        },
    }).mount(nav);
});
